import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { CONTACTS_GET_MANY } from 'api/query-keys.ts';
import type { ContactRes, CreateContactReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import type { WithPagination } from 'shared/utils/pagination.ts';

type THandleSuccessFn = (data: ContactRes) => void;

interface ICreateContactMutationOptions {
  handleSuccess?: THandleSuccessFn;
}

export const useCreateContact = (options?: ICreateContactMutationOptions) => {
  const queryClient = useQueryClient();

  return useMutationBase<ContactRes, unknown, CreateContactReq>({
    mutationFn: async (variables) => {
      const res = await http.post<ContactRes>('/v1/contacts', variables);

      return res.data;
    },

    onSuccess: (data) => {
      if (options?.handleSuccess) options.handleSuccess(data);

      const contactsData = queryClient.getQueryData<WithPagination<ContactRes[]>>([
        CONTACTS_GET_MANY,
        data.clientId,
      ]) || { data: [], pagination: null };

      queryClient.setQueryData([CONTACTS_GET_MANY, data.clientId], {
        ...contactsData,
        data: contactsData.data.concat(data),
      });
    },
  });
};
